import { Dialog, Button, DialogContent, DialogActions, DialogContentText} from "@mui/material"
import { Delete } from '@mui/icons-material'
import { useNotify, useTranslate } from 'react-admin'
import { useState } from "react"
import { useMutation } from "react-query";
import { RemoveMailServiceConfigurationCommand } from "../../GeneratedClients/FreeBillApi";
import { apiService } from "../../apiService";

const DeleteWithConfirmationButton = ({userId}: {userId: string}) => {

  const translate = useTranslate()
  const notify = useNotify()
  const [open, setOpen] = useState<boolean>(false)
  const { mutate: removeMailServiceConfiguration, isLoading } = useMutation((command: RemoveMailServiceConfigurationCommand) => 
    apiService.UsersApi.removeMailServiceConfiguration({removeMailServiceConfigurationCommand: command, id: userId})  
  )

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleDelete = async() => {
    removeMailServiceConfiguration({userId: userId}, {
      onSuccess(data) {
        notify(translate('ra.notification.deleted', {smart_count: 1}))
        handleClose()
      },
      onError(error: any) {
        notify(error, {type: 'error'})
      },
    })
  }

  return (
    <>
      <Button 
        size='small' 
        sx={{lineHeight: 1.5}} 
        color='error' 
        startIcon={<Delete />}
        onClick={handleOpen}
      >
        {translate('ra.action.delete')}
      </Button>
      <Dialog 
        open={open} 
        onClose={handleClose}
      >
        <DialogContent>
          <DialogContentText>
            {translate('ra.message.delete_content')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} >{translate('ra.action.cancel')}</Button>
          <Button color="error" onClick={handleDelete} >{translate('ra.action.delete')}</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default DeleteWithConfirmationButton